const toDistnct = (list: any[]) => Array.from(new Set(list));

export default toDistnct;
